export enum UploadDomain {
  ADMIN_POLICY_BOT_FILES = 'ADMIN_POLICY_BOT_FILES',
  ADMIN_PRIVATE_FILES = 'ADMIN_PRIVATE_FILES',
  ADMIN_PUBLIC_FILES = 'ADMIN_PUBLIC_FILES',
  ADMIN_VIDEOS = 'ADMIN_VIDEOS',
  // TODO (HCM): Tear down once we migrate to cases
  CONCERN_ATTACHMENTS = 'CONCERN_ATTACHMENTS',
  INTERNAL_PUBLIC_FILES = 'INTERNAL_PUBLIC_FILES',
}
